import {
    ShoppingCart as ShoppingCartTwoTone,
    UserCircle as PersonTwoTone,
} from "lucide-react";
import { Badge } from "../../../../components/ui/MenuPrimitives";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getAllProducts } from "../../../../api/action/products";
import { useCart } from "../../../../context/CartContext";
import { useTemplateAuthState } from "../../../../template/TemplateAuthState";


const AvikarHeader = () => {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const { isLoggedIn: isAuthenticated } = useTemplateAuthState();
    const userDetail = useSelector((state) => state?.auth?.data);
    const companyState = useSelector((state) => state.companyReducer?.company || {});
    const companyPrimayId = companyState?.primaryId;
    const [categories, setCategories] = useState([]);
    const { total_items } = useCart();
    const [isHeaderVisible, setIsHeaderVisible] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [dispatch, nav]);

    useEffect(() => {
        const fetchProducts = async (retries = 3, delay = 1000) => {
            try {
                if (!companyPrimayId) return;
                const response = await getAllProducts(companyPrimayId)(dispatch);

                if (response?.length > 0) {
                    const uniqueCategories = [
                        ...new Set(response.map((product) => product.category.name)),
                    ];
                    setCategories(uniqueCategories);

                }
            } catch {
                if (retries > 0) {
                    await new Promise((resolve) => setTimeout(resolve, delay));
                    fetchProducts(retries - 1, delay);
                }
            }
        };

        fetchProducts();
    }, [companyPrimayId, dispatch]);

    const handleCart = () => {
        if (!isAuthenticated) {
            nav("/sign-in");
            return;
        }
        nav("/cart");
    };

    useEffect(() => {
        const handleError = localStorage.getItem("handleError");
        if (handleError === "true") {
            setIsHeaderVisible(false);
        } else {
            setIsHeaderVisible(true);
        }

        const handleStorageChange = (event) => {
            if (event.key === "handleError") {
                setIsHeaderVisible(event.newValue !== "true");
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    if (!isHeaderVisible) {
        return null;
    }

    return (
        <>
            <div id="header" className="header sticky top-0 safe-area-top w-full bg-[#fdfaf6] shadow-md z-50 transition-shadow duration-300 ease-in-out">

                <div id="header-content" className={`mx-auto h-20 flex items-center justify-between px-2 sm:px-4 lg:px-6 max-w-12xl `}>
                    <Link to="/" title="Avikar Private Limited">
                        <img loading="lazy"
                            id="company-logo"
                            src={companyState?.logoImageContent?.displayLink || companyState?.logoURL || ""}
                            alt={companyState?.name || "Company Logo"}
                            className="h-12" />
                    </Link>

                    <div className="flex space-x-4">
                        {categories.map((category, index) => (
                            <button
                                id={`category-button-${index}`}
                                key={index}
                                className="text-gray-700 hover:text-[#f4a649] text-sm font-semibold tracking-wide font-[Poppins] transition duration-200"
                                onClick={() => nav(`/category/${category}`, { state: { name: category } })}
                            >
                                {category}
                            </button>
                        ))}
                    </div>



                    <div id="user-actions" className="flex items-center space-x-4">
                        {userDetail?.userRole !== "EMPLOYEE" && (
                            <>
                                {/* Service Link */}
                                <button
                                    onClick={() => nav("/at/service")}
                                    className="text-gray-700 hover:text-[#f4a649] text-sm font-semibold tracking-wide font-[Poppins] transition duration-200"
                                >
                                    Services
                                </button>

                                {/* Cart Icon */}
                                <Badge badgeContent={total_items} color="primary" onClick={handleCart}>
                                    <ShoppingCartTwoTone />
                                </Badge>
                            </>
                        )}

                        {!isAuthenticated ? (
                            <button
                                id="desktop-login-button"
                                className="bg-[#f4a649] text-white px-4 py-2 rounded-full text-sm hover:bg-[#f4a649cc] transition duration-300"
                                onClick={() => nav("/sign-in")}
                            >
                                Sign In
                            </button>
                        ) : (
                            <div id="nav-profile" onClick={() => nav("/profile")} className="relative cursor-pointer">
                                <PersonTwoTone className="text-gray-700" />
                            </div>
                        )}

                    </div>


                </div>

            </div>

        </>
    );
};

export default AvikarHeader;
